const Members = [
  {
    path: '/members',
    name: 'Members',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Equipe',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/member/Members.vue`),
    children: [
      // {
      //   //path: '/members/:id',
      //   path: '/members/edit_member_role/:id',
      //   name: 'EditMemberRole',
      //   meta: { 
      //     auth: true, 
      //     tab_name: 'Adicionar Membro',
      //     // roles: [Director, Manager, Supervisor],
      //   },
      //   component: () => import('@/components/member/members/EditMemberRole.vue'),
      // },
    ]
  },
  {
    path: '/newmember',
    name: 'NewMember',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Registrar membro',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/member/NewMember.vue`)
  },
  
]


export default Members
